import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material'
import { useState } from 'react'
import DateTextField from '../../components/DateTextField'

interface Props {
  open: boolean
  onClose: () => void
}

export default function ProcurementQualityPriceDialog({ open, onClose }: Props) {
  const [asOfDate, setAsOfDate] = useState(() => new Date().toISOString().slice(0, 10))

  const handleRefresh = () => {
    // Placeholder for Quality Price vs Basis refresh behavior.
    // Actual data loading will follow form_frmProcurementMainSubFormQualityPrice.txt and query_ProcurementQryQualityPrice.txt.
    void asOfDate
  }

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle sx={{ pb: 1 }}>
        <Typography variant="h6" fontWeight={700}>
          Quality Price vs Basis
        </Typography>
      </DialogTitle>
      <DialogContent dividers sx={{ pt: 1.5 }}>
        <Stack spacing={2}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
            <Typography variant="body2" fontWeight={700}>
              Date:
            </Typography>
            <DateTextField
              size="small"
              value={asOfDate}
              onChange={setAsOfDate}
              sx={{ width: 180 }}
              nativeInputProps={{ 'aria-label': 'Quality Price date' }}
            />
            <Button variant="outlined" size="small" onClick={handleRefresh}>
              Refresh Data
            </Button>
          </Box>

          <Typography variant="body2" color="text.secondary">
            This dialog will display the Quality Price vs Basis list from
            {' '}
            <strong>frmProcurementMainSubFormQualityPrice</strong>
            {' '}
            and
            {' '}
            <strong>query_ProcurementQryQualityPrice</strong>
            . Implementation of the grid and export/print behavior will follow the detailed Access evidence.
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 2, py: 1.25 }}>
        <Button variant="outlined" size="small" onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}
